<template>
  <!-- begin:: Footer -->
  <div class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop" id="kt_footer" >
    <div class="kt-container" v-bind:class="{ 'kt-container--fluid': isFluid() }">
      <div class="kt-footer__copyright">
        <a target="_blank" class="kt-link ml-1" ></a>
        <span class="ml-5"></span>
      </div>
      <div class="kt-footer__menu">
        <a target="_blank" class="kt-footer__menu-link kt-link"></a>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  methods: {
    /**
     * Check if footer container is fluid
     * @returns {boolean}
     */
    isFluid() {
      return this.layoutConfig("footer.self.width") === "fluid";
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  }
};
</script>
